// extracted by mini-css-extract-plugin
export default {"notesWrapper":"NotesTableCell_notesWrapper__JZHFj","notesText":"NotesTableCell_notesText__wVKdP"};